/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PolygonGeoJSON } from './PolygonGeoJSON';
import {
    PolygonGeoJSONFromJSON,
    PolygonGeoJSONFromJSONTyped,
    PolygonGeoJSONToJSON,
} from './PolygonGeoJSON';
import type { CampsiteGeoJSONProperties } from './CampsiteGeoJSONProperties';
import {
    CampsiteGeoJSONPropertiesFromJSON,
    CampsiteGeoJSONPropertiesFromJSONTyped,
    CampsiteGeoJSONPropertiesToJSON,
} from './CampsiteGeoJSONProperties';

/**
 * Campsite GeoJSON Schema
 * @export
 * @interface CampsiteGeoJSON
 */
export interface CampsiteGeoJSON {
    /**
     * ID
     * @type {string}
     * @memberof CampsiteGeoJSON
     */
    id: string;
    /**
     * Feature Type
     * @type {string}
     * @memberof CampsiteGeoJSON
     */
    type: string;
    /**
     * 
     * @type {PolygonGeoJSON}
     * @memberof CampsiteGeoJSON
     */
    geometry: PolygonGeoJSON;
    /**
     * 
     * @type {CampsiteGeoJSONProperties}
     * @memberof CampsiteGeoJSON
     */
    properties: CampsiteGeoJSONProperties;
}

/**
 * Check if a given object implements the CampsiteGeoJSON interface.
 */
export function instanceOfCampsiteGeoJSON(value: object): value is CampsiteGeoJSON {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('geometry' in value) || value['geometry'] === undefined) return false;
    if (!('properties' in value) || value['properties'] === undefined) return false;
    return true;
}

export function CampsiteGeoJSONFromJSON(json: any): CampsiteGeoJSON {
    return CampsiteGeoJSONFromJSONTyped(json, false);
}

export function CampsiteGeoJSONFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampsiteGeoJSON {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'geometry': PolygonGeoJSONFromJSON(json['geometry']),
        'properties': CampsiteGeoJSONPropertiesFromJSON(json['properties']),
    };
}

export function CampsiteGeoJSONToJSON(value?: CampsiteGeoJSON | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'geometry': PolygonGeoJSONToJSON(value['geometry']),
        'properties': CampsiteGeoJSONPropertiesToJSON(value['properties']),
    };
}

